var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"f-footer"},[(_vm.mobileView)?_c('toolbar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }